// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__X3QV6","importantInfo":"styles_importantInfo__KT8E_"};